<template>
    <div>
        <el-breadcrumb separator="/">
            <el-breadcrumb-item>代理商订单</el-breadcrumb-item>
        </el-breadcrumb>
        <el-card>
            <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
                <el-tab-pane label="充值订单" name="first">
                    <rechargeOrder v-if="activeName==='first'"></rechargeOrder>
                </el-tab-pane>
                <el-tab-pane label="VIP订单" name="second">
                    <vipOrder v-if="activeName==='second'"></vipOrder>
                </el-tab-pane>
            </el-tabs>
        </el-card>
    </div>
</template>

<script>
  import rechargeOrder from '../../components/agent/rechargeOrder';
  import vipOrder from '../../components/agent/vipOrder';

  export default {
    name: "User",
    components: {rechargeOrder, vipOrder},
    data() {
      return {
        activeName: 'first'
      }
    },
    created() {

    },
    methods: {
      handleClick(tab, event) {
        this.activeName = tab.name;
      }
    }
  }
</script>

<style scoped>
    .img {
        display: flex;
        align-items: center;
    }

    .img > img {
        margin-right: 10px;
    }
</style>